import { Link, useNavigate } from 'react-router-dom';
import api from "../../js/api";
import './Header.scss';
import Path from '../Path/Path';
import useAuth from '../../hooks/useAuth';
import { useContext } from 'react';
import { UserContext } from '../../js/UserContext';


export default function Header() {
    const navigate = useNavigate();
    const authenticated = useAuth();
    const { user } = useContext(UserContext);
    


    const goBack = () => {
        navigate(-1);
    };

    const stopImpersonating = () => {
        api.post('/impersonate').then(() => window.location.reload());
    }
    const impersonate = () => {
        if (!user.roles.includes('root') && !user.real_login) {
            return;
        }

        const login = prompt('Enter the login of the user you want to impersonate:');
        if (!login) {
            return;
        }

        api.post(`/impersonate/${login}`).then(() => window.location.reload());
    }

    return (
        <div id="header">

            <div className='left'>
                <Link to="" onClick={goBack} className="header-link logo"> &lt; </Link>
                <Link to="/" className="header-link logo"> Ratonera.net </Link>
            </div>

            <div className='header-links rigth'>
                {user?.real_login && (
                    <button onClick={stopImpersonating} className="header-link impersonate-button"> Stop impersonating </button>
                )}
                {user?.roles?.includes('root') && (
                    <button onClick={impersonate} className="header-link impersonate-button"> Impersonate </button>
                )}
                {authenticated ?
                    <Link to="/profile" className="header-link"> Profile </Link>
                    :
                    <Link to="/login" className="header-link"> Login </Link>
                }
            </div>
        </div>
    );
}